<template>
<div style="  height: 100vh;  display: inline-table;">
  <el-col :xs="23" :sm="23" :md="23" :lg="18" :xl="18" class="main-container">
    <el-col :span="24" style="  text-align: center;">
      <h1>Live Brokers</h1>
      <p class="page-subtitle">At SmartCharts we are committed to providing you with the best trading experience we can. That's why we have put together a list of brokers that are now compatible with SmartCharts live accounts. Simply choose the broker that you want to use, apply for a Live account and we'll sync it to your SmartCharts subscription so you can use it inside SmartCharts!</p>
    </el-col>
    <el-col :span="24" class="broker-list-container">

      <el-col :span="24" class="broker-list-wrapper">

        <div v-if="current_broker" class="current-broker-wrapper">
          <h2>Broker currently in use</h2>
          <div class="broker-list-item active">
            <el-col :span="24">
              <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" class="part-1" style="display: flex;">
                <div class="logo-icon-container"><i class="el-icon-warning-outline item-icon"></i></div>
                <div class="logo_container"><img :src="current_broker.logo"></div>
              </el-col>

              <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" class="part-2 c-account">

                <p>Current account: <strong>{{ current_broker.current_account }}
                    <!-- <i v-if="checkDuplicates(current_broker)" class="el-icon-arrow-down if-multi-broker" style="margin-left: 5px;"></i> -->
                    <el-select v-if="checkDuplicates(current_broker).length > 0" v-model="selectedOn" placeholder=" " :popper-append-to-body="false" class="caret-only-select" style="width: 10px !important;" @change="assignSelectedCurrent(selectedOn, null , current_broker)">
                      <el-option v-for="(item, index) in checkDuplicates(current_broker)" :key="item.account_id + index" :label="item.account_id" :value="item.account_id" />
                    </el-select>
                  </strong></p>
              </el-col>
              <el-col :span="1" class="part-divider">
                <p>|</p>
              </el-col>
              <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" class="part-3">

                <div v-if="selectedOn.status === 'Active'" class="dot green"></div>
                <div v-else-if="selectedOn.status === 'Pending'" class="dot yellow"></div>
                <div v-else class="dot yellow"></div>
  
                <p v-if="selectedOn.status !== 'pending'" class="active-label-status"> <strong>{{ current_broker.status }}</strong></p>
                <p v-else class="active-label-status"> <strong>Pending</strong></p>
                <!-- {{  compareCurrent(selectedOn) }} -->
              </el-col>
              <el-col v-if="selectedOn.status !== 'pending' && selectedOn.status !== 'None' " :xs="24" :sm="24" :md="4" :lg="7" :xl="7" class="part-4">
                <div class="item-btn item-btn-add-acct" @click="handleAddAcct(current_broker)">Add Account</div>
                <div v-if="checkIfSelected(current_broker)" class="item-btn" @click="triggerBrokerSwitch(current_broker)">Switch</div>
              </el-col>
              <el-col v-else :xs="24" :sm="24" :md="4" :lg="7" :xl="7" class="part-4 cus-addbtn">
                <div v-if="selectedOn.status" class="item-btn item-btn-add-acct" @click="handleAddAcct(current_broker)">Add Account</div>
                <!-- <div class="item-btn" @click="triggerBrokerSwitch(current_broker)">Switch</div> -->
              </el-col>
            </el-col>
          </div>
        </div>
        <!-- {{ duplicates }} -->
        <div v-if="other_broker.length > 0" class="current-broker-wrapper">
          <h2>My other brokers</h2>
          <div v-for="(other,i) in other_broker" :key="i" class="broker-list-item" :class="[other.status ===  'Pending'?'darkBlue' : 'normal']">
            <el-col :span="24">
              <el-col :xs="12" :sm="12" :md="8" :lg="8" :xl="8" class="part-1" style="display: flex;">
                <div class="logo-icon-container"><i class="el-icon-warning-outline item-icon" style=""></i></div>
                <div class="logo_container">
                  <img :src="other.logo">
                </div>
              </el-col>
              <el-col :xs="12" :sm="12" :md="4" :lg="4" :xl="4" class="part-2 c-account">
                <p>Current account: <strong>{{ other.current_account }}

                    <el-select v-if="checkDuplicatesOther(other,'other').length > 0" v-model="selectedOnOther" placeholder=" " :popper-append-to-body="false" class="caret-only-select" style="width: 10px !important;" @change="assignSelected(selectedOnOther, i,other, 'other')">
                      <el-option v-for="item in checkDuplicatesOther(other)" :key="item.account_id" :label="item.account_id" :value="item.account_id" />
                    </el-select>
                  </strong></p>
                <!-- <i class="el-icon-arrow-down if-multi-broker" style="margin-left: 5px;"></i> -->

              </el-col>
              <el-col :span="1" class="part-divider">
                <p>|</p>
              </el-col>
              <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4" class="part-3">
                <!-- {{ selectedOnOther }} -->
                <!-- Dot indicator -->
                <div v-if="selectedOnOther" class="dot yellow"></div>
                <div v-else>
                  <div v-if="other.status === 'Active'" class="dot green"></div>
                  <div v-else-if="other.status === 'Pending'" class="dot yellow"></div>
                </div>

                <!-- Status text -->

                <p v-if="selectedOnOther" class="active-label-status">
                  <strong>Pending</strong>
                </p>
                <p v-else class="active-label-status">
                  <strong>{{ other.status }}</strong>
                </p>

                <!-- {{ selectedOnOther }} -->
              </el-col>
              <el-col v-if="selectedOnOther" :xs="24" :sm="24" :md="4" :lg="7" :xl="7" class="part-4 p-4-cus">
                <div class="item-btn item-btn-add-acct" @click="handleAddAcct(other)">Add Account</div>
                <!-- <div class="item-btn" @click="triggerBrokerSwitch(other)">Switch</div> -->

              </el-col>
              <div v-else>
                <el-col v-if="other.status !== 'Pending'" :xs="24" :sm="24" :md="4" :lg="7" :xl="7" class="part-4 p-4-cus">
                  <div v-if="other.status" class="item-btn item-btn-add-acct" @click="handleAddAcct(other)">Add Account</div>
                  <div class="item-btn" @click="triggerBrokerSwitch(other)">Switch</div>

                </el-col>
              </div>

            </el-col>
          </div>
        </div>

        <div v-if="available_broker.length > 0" class="available-broker-wrapper">
          <h2 style="margin-bottom: 0px !importtant;">Brokers available to me</h2>
          <el-col :span="24" style="padding-left: 20px;padding-right: 20px;" class="brokers-available-sub">
            <el-col :span="5" class="part-1">
              <p></p>
            </el-col>
            <el-col :span="16" class="part-1">
              <el-col :span="6" class="available-types-title">
                <p>Foreign exchange</p>
              </el-col>

              <el-col :span="6" class="available-types-title">
                <p>Crypto</p>
              </el-col>

              <el-col :span="6" class="available-types-title">
                <p>Metals</p>
              </el-col>

              <el-col :span="6" class="available-types-title">
                <p>Indices</p>
              </el-col>
            </el-col>
          </el-col>
          <div v-for="(available,i) in available_broker" :key="i" class="broker-list-item" :class="[available.status ===  'Pending'?'darkBlue' : 'normal']">
            <el-col :span="24">
              <el-col :xs="24" :sm="24" :md="24" :lg="5" :xl="5" class="part-1" style="display: flex;">
                <div class="logo-icon-container"><i class="el-icon-link item-icon"></i></div>
                <div class="logo_container"><img :src="available.logo"></div>
              </el-col>
              <el-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16" class="part-2">
                <el-col :span="6" class="available-types-title available-item-check-container">
                  <span v-if="is_mobile" class="fx-label">FX</span><i class="el-icon-check available-icon-true"></i>
                </el-col>
                <el-col :span="6" class="available-types-title available-item-check-container">
                  <span v-if="is_mobile" class="fx-label">Crypto</span><i class="el-icon-check available-icon-true"></i>
                </el-col>
                <el-col :span="6" class="available-types-title available-item-check-container">
                  <span v-if="is_mobile" class="fx-label">Metals</span><i class="el-icon-close available-icon-false"></i>
                </el-col>
                <el-col :span="6" class="available-types-title available-item-check-container end">
                  <span v-if="is_mobile" class="fx-label">Indices</span><i class="el-icon-close available-icon-false"></i>
                </el-col>

              </el-col>
    

              <el-col :xs="24" :sm="24" :md="24" :lg="3" :xl="4" class="part-4 brokers-available" >
                <div class="item-btn btn-apply">Apply now</div>
              </el-col>
            </el-col>
          </div>
        </div>

      </el-col>
    </el-col>

  </el-col>

  <el-dialog title="Submit new trading account" :visible.sync="add_broker_dialog" width="30%" id="add_broker_dialog" :before-close="handleClose">
    <div>

      <el-form id="addBrokerForm" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" label-position="top">
        <el-form-item label="Email" prop="email">
          <el-input v-model="ruleForm.email" size="medium" type="email"></el-input>
        </el-form-item>
        <el-form-item label="Account ID" prop="account_id">
          <el-input v-model="ruleForm.account_id" size="medium"></el-input>
        </el-form-item>
     
      </el-form>

    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" type="success" @click="handleClose()">Cancel</el-button>
      <el-button size="small" type="success" @click="handleConfirm('ruleForm')">Confirm</el-button>

    </span>
  </el-dialog>

</div>
</template>

<script>
/* eslint-disable */
export default {
  name: "LiveBroker",
  data() {
    return {
      loading: false,
      current_broker: '',
      current_broker_orig: '',
      add_broker_dialog: false,
      ruleForm: {
        email: '',
        account_id: '',
        broker: ''
      },
      rules: {
        email: [{
            required: true,
            message: 'Please input email address',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Please input correct email address',
            trigger: ['blur', 'change']
          }
        ],
        account_id: [{
          required: true,
          message: 'Please input Broker Account ID',
          trigger: 'blur'
        }],

      },
      other_broker: [],
      account_to_add: {},
      available_broker: [],
      selectedOn: null,
      selectedOnOther: null,
      selected_trading_account: [],
      selected_trading_account_: [],
      pending_accounts: [],
      is_mobile: false,
      windowWidth: window.innerWidth,
      broker_list_orig: [],
      duplicates: [],
      code_token: '',
      new_selected_broker: null,
      broker_list: [{
          id: '1',
          logo: require('@/assets/logo_collections/CI_logo.webp'),
          name: 'capitalindex',
          current_account: '243678',
          status: 'Active',
          type: 'current',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '2',
          logo: require('@/assets/logo_collections/sc_logo_white.webp'),
          name: 'smartcharts',
          current_account: '213352',
          status: 'Active',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '3',
          logo: require('@/assets/logo_collections/errante_logo.webp'),
          name: 'Errante',
          current_account: '213352',
          status: 'Active',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '4',
          logo: require('@/assets/logo_collections/tickmill.webp'),
          name: 'Tickmill',
          current_account: '989721',
          status: 'Active',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '5',
          logo: require('@/assets/logo_collections/ic_markets.webp'),
          name: 'Markets',
          current_account: '215543',
          status: 'Pending',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '6',
          logo: require('@/assets/logo_collections/pepperstone.webp'),
          name: 'Pepperstone',
          current_account: '123700',
          status: 'Pending',
          type: 'available',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: false,
            indices: false,
          }
        },
        {
          id: '7',
          logo: require('@/assets/logo_collections/vt_markets.webp'),
          name: 'vt markets',
          current_account: '123701',
          status: 'Pending',
          type: 'available',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '8',
          logo: require('@/assets/logo_collections/think_markets.png'),
          name: 'Think Markets',
          current_account: '213353',
          status: 'Active',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '9',
          logo: require('@/assets/logo_collections/markets_com.png'),
          name: 'Markets.com',
          current_account: '813357',
          status: 'Active',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
        {
          id: '10',
          logo: require('@/assets/logo_collections/intertrader.png'),
          name: 'InterTrader',
          current_account: '813358',
          status: 'Active',
          type: 'other',
          options: {
            foreign_exchange: true,
            crypto: true,
            metals: true,
            indices: true,
          }
        },
      ]

    }
  },
  mounted() {
    const token = this.$cookies.get('token');
    window.addEventListener('resize', this.updateWidth())
    if (!this.new_selected_broker) {
      this.fetchUserDetails('first_load');
    }
  },
  methods: {
    updateWidth() {
      this.windowWidth = window.innerWidth
      if(this.windowWidth <= "767" || this.windowWidth <= 767) {
        this.is_mobile = true
      } else {
        this.is_mobile = false
      }
    },
    async handleConfirm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          const axios = require('axios');

          // Build payload for verification
          const payload = {
            email: this.ruleForm.email,
            broker: this.account_to_add.name,
            account_id: this.ruleForm.account_id
          };

          const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-SESSION-ID': this.$cookies.get('web_session_id')
          };

          const url = process.env.VUE_APP_API_URL + `/v1/users/trading-accounts/verification`;

          try {
            const response = await axios.post(url, payload, {
              headers
            });
            const result = response.data;

            const pending = result
            pending.status = 'pending'

            this.broker_list.push(pending)
            if (response) {
              this.$notify.success({
                title: 'Success',
                message: 'Submited succesfuly',
                // duration: 0
              });
            }

            this.add_broker_dialog = false;
          } catch (error) {
            console.error("Verification request failed:", error.response?.data || error.message);
            this.add_broker_dialog = false;
          } finally {
            this.loading = false;
          }

        } else {
          console.log('error submit!!');
          this.add_broker_dialog = false;
          return false;
        }
      });
    },
    handleClose() {
      this.add_broker_dialog = false
    },
    handleAddAcct(data) {
      this.account_to_add = data
      this.add_broker_dialog = true
    },
    checkIfSelected(data) {
       if (data.account_id === this.selected_trading_account_.account_id) {

          return false
        }

    },
    assignSelectedCurrent(data, index, from, other) {

      const found = this.broker_list.find(item => item.account_id === data);

    
      if (data === this.selected_trading_account_.account_id) {

            // alert('s')
          // this.selectedOnOther = null
          
          // this.selectedOn = found
          
          const set = {
            account_id: this.selectedOn,
            status: 'Active',
            show: 'hide'
          }
          this.selectedOn = set
          this.current_broker.status = 'Active'
          return
      }

      
      if (!found) {
        // alert('h')
        // this.selectedOnOther = null
        return;
      }

      // Find matching broker source (from either current or other) to extract static data like logo, options, etc.
      const allBrokers = this.broker_list_orig

      const baseBroker = allBrokers.find(
        broker => broker.name?.toLowerCase() === (found.broker?.toLowerCase() || found.name?.toLowerCase())
      )

      let logo = ''

      if (found.logo) {
        logo = found.logo

      } else {
        logo = baseBroker.logo
      }

      let current_broker = {
        id: baseBroker?.id || found.id,
        logo: logo,
        name: found.broker?.toLowerCase() || found.name?.toLowerCase(),
        current_account: found.account_id,
        status: found.status || baseBroker?.status || "Active",
        type: index !== undefined && index !== null && index !== ''?"other" : "current",
        options: baseBroker?.options || {
          foreign_exchange: true,
          crypto: true,
          metals: true,
          indices: true
        },
        account_id: found.account_id,
        trading_account_type: found.trading_account_type,
        class_name: found.class_name,
        account_data: {
          ...found
        }
      };

      this.selectedOn = current_broker
      this.current_broker = current_broker
      return current_broker
  

    },
    assignSelected(data, index, from, other) {

      const found = this.duplicates.find(item => item.account_id === data);

      if (other) {

        if (data === from.account_id) {

          this.selectedOnOther = null
          // this.selectedOn = null
          return
        }

      }
      if (!found) {

        return;
      }

      // Find matching broker source (from either current or other) to extract static data like logo, options, etc.
      const allBrokers = [this.current_broker, ...this.other_broker];
      const baseBroker = allBrokers.find(
        broker => broker.name?.toLowerCase() === found.broker?.toLowerCase()
      )

      let current_broker = {
        id: baseBroker?.id || found.id,
        logo: baseBroker?.logo || null,
        name: found.broker?.toLowerCase() || "unknown",
        current_account: found.account_id,
        status: found.status || baseBroker?.status || "Active",
        type: index !== undefined && index !== null && index !== ''?"other" : "current",
        options: baseBroker?.options || {
          foreign_exchange: true,
          crypto: true,
          metals: true,
          indices: true
        },
        account_id: found.account_id,
        trading_account_type: found.trading_account_type,
        class_name: found.class_name,
        account_data: {
          ...found
        }
      };
      
      if (index !== undefined && index !== null && index !== '') {
        this.other_broker[index] = current_broker;
        alert('sd')
        this.selectedOnOther = current_broker;
      } else {
        this.current_broker = current_broker;
        this.selectedOn = current_broker;
      }

    },
    compareCurrent(data) {

      if (!data || !this.current_broker_orig) return false;
      let acc_id = ''
      if (!data.account_id) {
        acc_id = data
      } else {
        acc_id = data.account_id
      }

      if (acc_id !== this.current_broker_orig.account_id) {
        return true
      } else {
        return false
      }
    },
    compareOther(data) {

      if (!data || !this.current_broker_orig) return false;
      let acc_id = ''
      if (!data.account_id) {
        acc_id = data
      } else {
        acc_id = data.account_id
      }

      if (acc_id !== this.current_broker_orig.account_id) {
        return true
      } else {
        return false
      }
    },
    checkDuplicates(data) {
      const broker = data.name?.toLowerCase();
      if (!broker) return [];

      const seenAccountIds = new Set();

      const matches = this.broker_list
        .filter(item => item.account_data?.broker?.toLowerCase() === broker)
        .map(item => ({
          id: data.id,
          logo: data.logo,
          name: data.name,
          current_account: item.account_id,
          status: item.status || data.status,
          type: 'other',
          options: data.options,
          account_id: item.account_id,
          trading_account_type: item.trading_account_type,
          class_name: item.class_name,
          account_data: {
            ...item.account_data
          }
        }))
        .filter(item => {
          if (seenAccountIds.has(item.account_id)) {
            return false;
          }
          seenAccountIds.add(item.account_id);
          return true;
        });

      return matches;
    },

    checkDuplicatesOther(data) {
      const broker = data.name?.toLowerCase();
      if (!broker) return [];

      const seen = new Set();
      const matches = this.broker_list
        .filter(item => {
          const nameMatch = item.name?.toLowerCase() === broker;
          const brokerMatch = item.broker?.toLowerCase() === broker;
          return nameMatch || brokerMatch;
        })
        .map(item => ({
          id: data.id,
          logo: data.logo,
          name: data.name,
          current_account: item.account_id,
          status: item.status || data.status,
          type: 'other',
          options: data.options,
          account_id: item.account_id,
          trading_account_type: item.trading_account_type,
          class_name: item.class_name,
          account_data: {
            ...item.account_data
          }
        }))
        .filter(item => {
          if (seen.has(item.account_id)) {
            return false;
          }
          seen.add(item.account_id);
          return true;
        });

      return matches;
    },

    async fetchUserDetails(value) {
      this.loading = true;
      const axios = require('axios');
      const payload = {
        // your request body here
      };
      const query = this.$route.query;
      this.code_token = query.code

      const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        // 'X-SESSION-ID': this.$cookies.get('web_session_id')
      };

      const url = process.env.VUE_APP_API_URL + `/v1/users?code=` + this.code_token;

      try {
        axios.post(url, payload, {
          headers
        }).then(response => {
          const user_details = response.data;
          const url2 = process.env.VUE_APP_API_URL + `/v1/users/trading-accounts`;

          axios.get(url2, {
            params: {
              code: this.code_token,
              ...payload // optional, if you have extra query params
            },
            headers: headers
          }).then(response2 => {
            const user_details2 = response2.data;
            if (user_details.signedIn) {

              const selected_trading_account = user_details.user.selected_trading_account;
              this.pending_accounts = user_details2.broker_verification
              // const trading_accounts = user_details.user.trading_accounts || [];

              const trading_accounts = user_details2.trading_accounts || []

              this.trading_accounts = trading_accounts;

              const brokerCount = {};
              this.duplicates = [];

              this.selected_trading_account_ = selected_trading_account

              trading_accounts.forEach(account => {
                const broker = account.broker;

                if (!broker) return;

                brokerCount[broker] = (brokerCount[broker] || 0) + 1;
              });

              for (const broker in brokerCount) {
                if (brokerCount[broker] > 1) {
                  const duplicateAccounts = trading_accounts.filter(a => a.broker === broker);
                  this.duplicates.push(...duplicateAccounts);
                }
              }

              this.sterilizeData()

              this.broker_verification_accounts = user_details.user.broker_verification;

              // Merge real data into static broker list
              this.mergeBrokerDataWithAccounts(selected_trading_account, trading_accounts);

              if (value && selected_trading_account) {
                const new_data = {
                  account_type: selected_trading_account.account_type || selected_trading_account.trading_account_type,
                  account_id: selected_trading_account.account_id,
                  client_id: selected_trading_account.client_id,
                  broker: selected_trading_account.broker
                };

                // Update selected trading account and trigger UI reflow
                this.selectTradingAccount(new_data, 'first_load');
              }

              this.loading = false;

            } else {
              this.logout();
            }
          })
        });
      } catch (error) {
        this.loading = false;
        console.error("Error fetching user details:", error.response?.data || error.message);
      }
    },

    logout() {
      console.log('logout')
      localStorage.removeItem('web_session_id')
      localStorage.clear()
      const allCookies = this.$cookies.keys();
      allCookies.forEach((cookie) => {
        this.$cookies.remove(cookie);
      });
      sessionStorage.clear()
      localStorage.setItem('logout', true);
      this.$cookies.set('logout', true)
      this.$cookies.remove('web_session_id')
      // window.location.href = '/';
      this.$router.push('/login');
      this.loading = false
    },

    async getBrokers() {
      const axios = require('axios');
      const url = process.env.VUE_APP_API_URL + `/v1/brokers?code=` + this.code_token;

      try {
        const response = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          withCredentials: false
        });

        return response.data;
      } catch (error) {
        this.loading = false;
        this.logout();
      }
    },
    getBrokerAppUrl(new_brokers) {
      let _brokers_arr = this.new_selected_broker
      const brokerKey = _brokers_arr?.broker?.trim().toLowerCase();

      if (brokerKey && new_brokers[brokerKey]) {
        const matchedBroker = new_brokers[brokerKey];

        return matchedBroker;
      }

      console.warn("Broker not found");
      return null;
    },
    async handleProceed() {
      this.loading = true;
      const axios = require('axios');

      let app_url = '';
      const new_brokers = await this.getBrokers();

      if (new_brokers) {
        const match_broker = this.getBrokerAppUrl(new_brokers);

        if (match_broker) {
          app_url = match_broker.app_url?.replace(/\s+/g, '').trim();

        }
      }

      // return

      const path = this.$route.path; // "/smartchart/register"
      const segments = this.$route.path.split('/'); // ["", "smartchart", "register"]
      const base = window.location.origin; // "http://localhost:8081"
      const query = this.$route.query; // { b: "smartcharts" }

      // Extract subdomain (if present)
      const hostnameParts = window.location.hostname.split('.');
      let subdomain = null;

      // Example: smartchart.localhost or smartchart.example.com
      if (hostnameParts.length > 2) {
        subdomain = hostnameParts[0]; // "smartchart"
      } else if (hostnameParts.length === 2 && hostnameParts[0] !== 'localhost') {
        subdomain = hostnameParts[0]; // "smartchart" (when not localhost)
      }

      console.log('Subdomain:', subdomain);
      console.log('Base URL:', base);
      console.log('Full path:', path);
      console.log('First segment:', segments[1]); // "smartchart"
      console.log('Second segment:', segments[2]); // "register"
      console.log('Query parameter b:', query.b); // "smartcharts"

      let base_ = window.location.origin.replace(/^https?:\/\//, '');

      const env = process.env.VUE_APP_ENV
      if (env === 'local') {
        base_ = 'localhost'
      } else {
        const hostnameParts = window.location.hostname.split('.');
        const root_domain = hostnameParts.reverse()
        base_ = root_domain[1]
      }
      let new_data = {
        "selected_trading_account": {
          "account_type": this.new_selected_broker.account_type,
          "account_id": this.new_selected_broker.account_id,
          "client_id": this.new_selected_broker.client_id,
          "broker": this.new_selected_broker.broker,
          "myaccount_instance": base_

        }
      }

      // const payload = this.new_selected_broker;

      const headers = {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        // 'X-SESSION-ID': this.$cookies.get('web_session_id')
      };

      const url = process.env.VUE_APP_API_URL + `/v1/users/get-token?code=` + this.code_token;

      try {
        const response = await axios.post(url, new_data, {
          headers
        });
        const _new_user_details = response.data;
        
        if (_new_user_details && _new_user_details.token) {
          const new_token = _new_user_details.token;

          this.app_url = `${app_url}/?token=${new_token}`;

          if (_new_user_details.web_session_id) {
            // localStorage.setItem("web_session_id", _new_user_details.web_session_id);
            this.$cookies.set('web_session_id', _new_user_details.web_session_id);
          }
          const fullSessionUrl = this.$cookies.get('session_token_url')

          if (fullSessionUrl) {
            const baseSessionUrl = fullSessionUrl.split('?')[0];

            const encodedBaseSessionUrl = encodeURIComponent(baseSessionUrl);

            const finalUrl = this.app_url + `&session_token_url=${encodedBaseSessionUrl}`;

            window.location.href = finalUrl;

            
          } else {
            console.error('session_token_url not found in localStorage');
          }
        }
      } catch (error) {
        this.loading = false;
        console.error("Error fetching user details:", error.response?.data || error.message);
      }
    },
    triggerBrokerSwitch(broker) {
      this.new_selected_broker = {
        broker: broker.name,
        account_id: broker.account_id,
        client_id: broker.current_account,
        account_type: broker.trading_account_type
      };
      this.handleProceed();
    },
    handleSwitch(data) {
      let data_list = this.broker_list
      data_list.forEach((item, i) => {
        if (item.type === 'current') {
          item.type = 'other'
        }
        if (item.id === data.id) {
          item.type = 'current'
        }
      })
      this.sterilizeData(data_list)
    },
    selectTradingAccount(selected, value) {
      if (!selected) return;

      this.selected_trading_account = selected.account_id;
      this.broker_name = selected.broker.toUpperCase();

      let acct_type = value?selected.account_type : selected.trading_account_type;

      let _selected_trading_account = {
        account_id: selected.account_id,
        account_type: acct_type,
        client_id: selected.client_id || selected.account_id,
        broker: selected.broker
      };

      this.new_selected_broker = _selected_trading_account;

      this.broker_list = this.broker_list.map(item => {
        if (
          item.name.toLowerCase() === selected.broker.toLowerCase()
        ) {
          return {
            ...item,
            type: 'current'
          };
        } else if (item.type === 'current') {
          return {
            ...item,
            type: 'other'
          };
        }
        return item;
      });

      this.sterilizeData();

      this.loading = false;
    },
    mergeBrokerDataWithAccounts(selected_trading_account, trading_accounts) {

      this.broker_list = this.broker_list.map(staticBroker => {
        const matchedAccount = trading_accounts.find(acc =>
          acc.broker?.toLowerCase() === staticBroker.name?.toLowerCase()
        );

        if (matchedAccount) {
          return {
            ...staticBroker,
            current_account: matchedAccount.account_id,
            account_id: matchedAccount.account_id,
            trading_account_type: matchedAccount.trading_account_type,
            class_name: matchedAccount.class_name,
            status: matchedAccount.status || 'Pending',
            type: 'other', // initially mark as "other"
            account_data: matchedAccount
          };
        }

        return {
          ...staticBroker,
          type: 'available',
        };
      });

      if (selected_trading_account) {
        const brokerName = selected_trading_account.broker?.toLowerCase();
        const matchedStaticBroker = this.broker_list.find(b =>
          b.name?.toLowerCase() === brokerName
        );

        const selectedBrokerEntry = {
          ...(matchedStaticBroker || {}),
          name: brokerName,
          current_account: selected_trading_account.account_id,
          account_id: selected_trading_account.account_id,
          trading_account_type: selected_trading_account.trading_account_type,
          class_name: selected_trading_account.class_name,
          status: selected_trading_account.status || 'Active',
          type: 'current',
          account_data: selected_trading_account
        };

        this.broker_list.push(selectedBrokerEntry);
      }

      this.sterilizeData();
    },
    normalizeName(name) {
      return name.trim().toLowerCase().replace(/\s+/g, '_');
    },
    updateBrokerList(staticList, apiData) {
      return staticList.map(broker => {
        const normalizedName = this.normalizeName(broker.name);
        const apiMatch = apiData[normalizedName];

        if (apiMatch) {
          return {
            ...broker,
            type: apiMatch.status.toLowerCase() // use 'status' as new 'type'
          };
        }

        return broker; // unchanged if no match
      });
    },

    async sterilizeData() {
      const response = await this.getBrokers();
      const apiData = response || {};

      // Update static broker_list with API statuses
      this.broker_list = this.updateBrokerList(this.broker_list, apiData);

      // Merge pending accounts into broker_list
      const pendingFormatted = (this.pending_accounts || []).map(pending => ({
        id: `pending-${pending.id}`,
        name: pending.broker?.toLowerCase() || '',
        status: 'pending',
        account_id: pending.account_id,
        type: 'pending',
        account_data: {
          id: pending.id,
          broker: pending.broker,
          account_id: pending.account_id,
          status: 'pending'
        }
      }));

      this.broker_list = [...this.broker_list, ...pendingFormatted];


      // Categorize the brokers
      const currentList = [];
      const otherList = [];
      const availableList = [];

      const selectedAccount = this.selected_trading_account_;
      const tradingAccounts = this.trading_accounts || [];

      this.broker_list.forEach(broker => {
        const brokerName = broker.name?.toLowerCase();

        // Match current selected trading account
        if (
          selectedAccount &&
          selectedAccount.broker?.toLowerCase() === brokerName &&
          selectedAccount.account_id === broker.account_id
        ) {
          broker.type = 'current';
          currentList.push(broker);
          return;
        }

        // Match against other trading accounts
        const matchInOthers = tradingAccounts.find(
          acc =>
          acc.broker?.toLowerCase() === brokerName &&
          acc.account_id === broker.account_id
        );

        if (matchInOthers) {
          broker.type = 'other';
          otherList.push(broker);
          return;
        }

        // If no match, it's available
        if (broker.type !== 'pending') {
          broker.type = 'available';
          availableList.push(broker);
        }
      });
      this.broker_list_orig = this.broker_list
      // Assign to component data
      this.current_broker = this.selectedOn || currentList[0] || null;
      this.current_broker_orig = this.current_broker;

      this.selectedOn = this.current_broker;

      this.other_broker = otherList.filter(
        broker => broker.name?.toLowerCase() !== this.current_broker?.name?.toLowerCase()
      );

      this.available_broker = availableList;

    }
  }
}
</script>

<style scoped>
.current-broker-wrapper {
  padding-bottom: 0px !important;
  margin-top: 40px;
  text-align: center;
}

.main-container {
  float: none !important;
  margin: 0 auto !important;
  color: #ffffff !important;
  padding-top: 10vh;
}

.broker-list-wrapper {
  text-align: left;
}

.broker-list-wrapper h2 {
  font-weight: 300 !important;
  font-size: 22px;
  margin-top: 40px;
  margin-bottom: 20px;
  text-align: left !important;
}

.broker-list-item {
  /* background-color: #3c4f6d; */
  transition: box-shadow 0.3s ease;
  background: linear-gradient(to right, #3f4f75, #3f3b5e);
  padding: 20px;
  display: flex;
  border-radius: 5px;
  height: 30px;
}

.logo_container img {
  /* width: 60px; */
  margin-left: 40px;
  width: auto;
  height: 30px;
}

.logo_container {}

.part-2 p,
.part-3 p,
.part-divider p {
  margin-block-start: 0px !important;
  margin-block-end: 0px !important;
  padding-top: 5px;
}

.part-2 p {
  color: #ffffff80;
}

.part-2 p strong {
  color: #ffffff;
}

.part-divider {
  text-align: center;
  color: #ffffff3d;
}

.broker-list-item.active {
  box-shadow: inset 0px 0px 0px 1px #93ca85;
}

.item-icon {
  transform: rotate(180deg) !important;
  color: #ffffff80;
  font-size: 20px;
  margin-left: 20px;
}

.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  float: left;
  margin-top: 10px;
  margin-right: 5px;
}

.green {
  background-color: #93ca85;
}

.yellow {
  background-color: #e2ca5d;
}

.broker-list-item {
  margin-bottom: 10px;
}

.part-4 {
  float: right;
  text-align: center;

}

.broker-list-item:hover {
  box-shadow: inset 0px 0px 0px 1px #93ca85;
}

.item-btn {
  float: right;
  text-align: center;
  box-shadow: inset 0px 0px 0px 1px #93ca85;
  padding: 5px 20px;
  border-radius: 3px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.item-btn:hover {
  background-color: #93ca855c;
  transition: background-color 0.3s ease;
}

.darkBlue {
  background: #283a5d !important;
}

.available-types-title {
  text-align: center;
  color: #ffffffb3;
}

.available-icon-true {
  border-radius: 50%;
  /* background-color: #93ca85; */
  background-color: #5a954b;
  padding: 3px;
}

.available-icon-false {
  border-radius: 50%;
  /* background-color: #ea7374; */
  background-color: #e44f51;
  font-weight: bold;
  padding: 3px;
}

.item-btn.btn-apply {
  padding: 5px 24px;
}

.available-item-check-container {
  border-right: 1px solid #ffffff3d;
  margin-top: 5px;
}

.available-item-check-container.end {
  border-right: none !important;
}

.page-subtitle {
  color: #adc0ff;
  font-size: 20px;
}

.logo-icon-container {
  margin-left: -10px;
  display: flex;
  align-items: center;
  align-content: center;
  margin-top: -5px;
}

.available-broker-wrapper {
  padding-bottom: 10vh;
}

.available-broker-wrapper h2 {
  margin-bottom: 0px !important;
}

.broker-item-list {
  box-shadow: 1px 2px 3px #00000021;

}

.logo_container img {
  margin-left: 40px !important;
}

@media screen and (max-width: 767px) {
  .broker-list-item {
    height: 131px !important;
  }
.part-2 p {
  margin-left: -36px !important;
}
  .part-1.el-col.el-col-24.el-col-xs-12.el-col-sm-12.el-col-md-8.el-col-lg-8.el-col-xl-8 {
      width: 100% !important;
    height: 47px;
    border-bottom: 1px solid #4a5c8b;
    margin-bottom: 20px;;
  }
  .logo-icon-container {
      top: 27px !important;
    right: 35px !important;
    position: absolute !important;
    display: inline-block !important;
  }
  .part-3 {
      margin-bottom: 5px !important;
  }
  .logo_container img {
    margin-left: 9px !important;
  }

   .brokers-available {
     margin-top: 20px !important;
     text-align: center !important;
   }
   .brokers-available .item-btn {
     float:none !important;
   }

   .brokers-available-sub {
      visibility: hidden !important;
    height: 25px !important;
   }
}
</style>
